const theme = {
    colors: {
      primary: ' #01257D',     // Deep Blue
      secondary: ' #FF6F3C',   // Orange Accent
      background: ' #FFFFFF',  // White
      lightGray: ' #E6E6E6',   // Light Silver
      darkGray: ' #7B7B7A',    // Steel Gray
      text: ' #333333',        // Dark text
    },
    fonts: {
      heading: "'Montserrat', sans-serif",
      body: "'Roboto', sans-serif",
    },
    breakpoints: {
      mobile: '576px',
      tablet: '768px',
      laptop: '992px',
      desktop: '1200px',
    },
    spacing: {
      xs: '0.25rem',
      sm: '0.5rem',
      md: '1rem',
      lg: '1.5rem',
      xl: '2rem',
      xxl: '3rem',
    },
    borderRadius: {
      small: '4px',
      medium: '8px',
      large: '12px',
    },
    shadows: {
      small: '0 2px 4px rgba(0, 0, 0, 0.1)',
      medium: '0 4px 8px rgba(0, 0, 0, 0.1)',
      large: '0 8px 16px rgba(0, 0, 0, 0.1)',
    },
  };
  
  export default theme;
  